import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Newsletter Section */}
        <div className="footer-newsletter">
          <div className="newsletter-content">
            <h2>Stay Updated</h2>
            <p>Get the latest insights on market trends and investment opportunities delivered to your inbox.</p>
          </div>
          <div className="newsletter-form">
            <input 
              type="email" 
              placeholder="Enter your email" 
              className="newsletter-input"
              aria-label="Email for newsletter"
            />
            <button className="newsletter-button">
              Subscribe
              <ArrowUpRight size={18} />
            </button>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="footer-top">
          {/* Company Info */}
          <div className="footer-section footer-about">
            <Link to="/" className="footer-logo">
              <span className="logo-text">Swanpoint</span>
            </Link>
            <p className="footer-description">
              Transforming the way you invest with cutting-edge quantitative strategies, advanced analytics, and expert market insights.
            </p>
            <div className="footer-social">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Facebook"
                className="social-link"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Twitter"
                className="social-link"
              >
                <Twitter size={20} />
              </a>
              <a 
                href="https://www.linkedin.com/company/swanppoint/?viewAsMember=true" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="LinkedIn"
                className="social-link"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/team">Our Team</Link></li>
              <li><Link to="/portfolio">Our Funds</Link></li>
              <li><Link to="/news">News & Insights</Link></li>
            </ul>
          </div>

          {/* Investors */}
          <div className="footer-section">
            <h3 className="footer-title">For Investors</h3>
            <ul className="footer-links">
              <li><Link to="/signup">Open Account</Link></li>
              <li><Link to="/login">Investor Login</Link></li>
              <li><Link to="/portfolio">Fund Performance</Link></li>
              <li><Link to="/financial-analyzer">Market Analysis</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div className="footer-section">
            <h3 className="footer-title">Resources</h3>
            <ul className="footer-links">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/faq">FAQs</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-title">Get in Touch</h3>
            <ul className="footer-contact">
              <li className="contact-item">
                <Mail size={18} />
                <div className="contact-details">
                  <span className="contact-label">Email</span>
                  <a href="mailto:growth_sphere@outlook.com">growth_sphere@outlook.com</a>
                </div>
              </li>
              <li className="contact-item">
                <MapPin size={18} />
                <div className="contact-details">
                  <span className="contact-label">Location</span>
                  <span>New York, NY</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} Swanpoint Investment Management. All rights reserved.
          </p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">•</span>
            <Link to="/terms">Terms of Service</Link>
            <span className="separator">•</span>
            <Link to="/contact">Contact</Link>
          </div>
          <p className="footer-disclaimer">
            Investment involves risk. Past performance does not guarantee future results.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;